import {DialogProps} from 'components/Dialog';
import React from 'react';
import {asyncType} from '../../../redux/helpers';

export const layoutReducerKey = 'layout';

export default {
   LOAD_TREE_NAV: asyncType(`${layoutReducerKey}/LOAD_TREE_NAV`),
   TREE_SEARCH: `${layoutReducerKey}/TREE_SEARCH`,
   GET_STATES: asyncType(`${layoutReducerKey}/GET_STATES`),
   UPDATE_STATES_FULL: asyncType(`${layoutReducerKey}/UPDATE_STATES_FULL`),
   UPDATE_TREE_STATE: `${layoutReducerKey}/UPDATE_TREE_STATE`,
   OPEN_DIALOG: `${layoutReducerKey}/OPEN_DIALOG`,
   OPEN_SUB_DIALOG: `${layoutReducerKey}/OPEN_SUB_DIALOG`,
   CLOSE_SUB_DIALOG: `${layoutReducerKey}/CLOSE_SUB_DIALOG`,

   GET_NUM_JOB_HISTORIES: asyncType(`${layoutReducerKey}/GET_NUM_JOB_HISTORIES`),
   TEST_SQL_AUDIT_DB_CONNECTION: asyncType(`${layoutReducerKey}/TEST_SQL_AUDIT_DB_CONNECTION`),
   TEST_INBOUND_EMAIL_SERVER: asyncType(`${layoutReducerKey}/TEST_INBOUND_EMAIL_SERVER`),
   TEST_OUTBOUND_EMAIL_SERVER: asyncType(`${layoutReducerKey}/TEST_OUTBOUND_EMAIL_SERVER`),
   LOAD_CALENDARS: asyncType(`${layoutReducerKey}/LOAD_CALENDARS`),
   ADD_CALENDAR: asyncType(`${layoutReducerKey}/ADD_CALENDAR`),
   UPDATE_CALENDAR: asyncType(`${layoutReducerKey}/UPDATE_CALENDAR`),
   DELETE_CALENDAR: asyncType(`${layoutReducerKey}/DELETE_CALENDAR`),

   AUDIT_ARCHIVE_NOW: asyncType(`${layoutReducerKey}/AUDIT_ARCHIVE_NOW`),
   GET_SUSPEND_ALL: asyncType(`${layoutReducerKey}/GET_SUSPEND_ALL`),
   SUSPEND_TRANSACTION_FOLDER: asyncType(`${layoutReducerKey}/SUSPEND_TRANSACTION_FOLDER`),

   LOAD_USER_ADMINS: asyncType(`${layoutReducerKey}/LOAD_USER_ADMINS`),
   ADD_USER_ADMIN: asyncType(`${layoutReducerKey}/ADD_USER_ADMIN`),
   UPDATE_USER_ADMIN: asyncType(`${layoutReducerKey}/UPDATE_USER_ADMIN`),
   DELETE_USER_ADMIN: asyncType(`${layoutReducerKey}/DELETE_USER_ADMIN`),

   GET_AUTH_POLICIES: asyncType(`${layoutReducerKey}/GET_AUTH_POLICIES`),
   POST_AUTH_POLICIES: asyncType(`${layoutReducerKey}/POST_AUTH_POLICIES`),

   GET_PASSWORD_DATA: asyncType(`${layoutReducerKey}/GET_PASSWORD_DATA`),
   POST_PASSWORD_DATA: asyncType(`${layoutReducerKey}/POST_PASSWORD_DATA`),

   GET_ARCHIVE_USED: asyncType(`${layoutReducerKey}/GET_ARCHIVE_USED`),
   GET_ARCHIVE_DATE_RANGE: asyncType(`${layoutReducerKey}/GET_ARCHIVE_DATE_RANGE`),
   POST_AUDIT_REPORT_PARAMS: asyncType(`${layoutReducerKey}/POST_AUDIT_REPORT_PARAMS`),

   SET_ACTIVE_DIALOG_STATUS: `${layoutReducerKey}/SET_ACTIVE_DIALOG_STATUS`,
   CLEAR_ACTIVE_DIALOG_STATUS: `${layoutReducerKey}/CLEAR_ACTIVE_DIALOG_STATUS`,

   SEND_SUPPORT_TICKET: asyncType(`${layoutReducerKey}/SEND_SUPPORT_TICKET`),

   TOGGLE_PANEL: `${layoutReducerKey}/TOGGLE_PANEL`,
   TOGGLE_ALL_PANELS: `${layoutReducerKey}/TOGGLE_ALL_PANELS`,

   CHANGE_JOB_MONITOR_COLUMNS_ORDER: `${layoutReducerKey}/CHANGE_JOB_MONITOR_COLUMNS_ORDER`,
};

export type IDialogProps = {
   id: string;
   title?: string;
   content?: string | React.ReactNode;
   data?: any;
   maxWidth?: DialogProps['maxWidth'];
   onClose?: (data: any) => void;
};
